export const openSelectOnFocus = event => {
    const select = event.target;

    if (!select.matches('od-select:focus-visible')
        || select.contains(event.relatedTarget)
        || select.classList.contains('active')) {
        return;
    }

    select.open();
};
